<template>
    <el-row type="flex" class="row-bg" justify="center" align="center">
        <el-col :span="24">
            <div class="auth-form-wrap">
                <div class="wrap-logo">
                    <img src="@/assets/pvh-24.png" alt="" class="login-logo">
                </div>
                <div class="auth-block" v-loading="loading">
                    <h2>авторизация</h2>
                    <div class="description">
                        Введите свои данные в форме
                    </div>
                    <el-form
                        ref="form"
                        :model="model.fields"
                        :rules="model.rules"
                        @submit.native.prevent="onSubmit"
                        :inline-message="false"
                        :show-message="false"
                    >
                        <el-form-item
                            prop="email"
                            class="wrap-input-auth"
                            :class="{'auth-block-error-input': showError}"
                        >
                            <el-input
                                type="login"
                                size="medium"
                                :placeholder="model.attributeLabels.email"
                                v-model="model.fields.email"
                            />
                        </el-form-item>
                        <el-form-item
                            prop="password"
                            class="wrap-input-auth"
                            :class="{'auth-block-error-input': showError}"
                            @keyup.enter="onSubmit"
                        >
                            <el-input
                                type="password"
                                size="medium"
                                :placeholder="model.attributeLabels.password"
                                v-model="model.fields.password"
                            />
                            <div class="el-form-item__error wrap-input-auth auth-block-error-message" v-if="showError">
                                Логин или пароль указаны неверно
                            </div>
                        </el-form-item>
                        <el-form-item class="wrap-input-auth">
                            <el-button type="warning" native-type="submit" class="auth-block-button">
                                Войти
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-col>
    </el-row>
</template>

<script>
import LoginForm from '@/models/LoginForm';
import '@/assets/styles/login.scss';

export default {
    name: 'Login',
    data() {
        return {
            model: new LoginForm(),
            showError: false,
            loading: false
        };
    },
    methods: {
        onSubmit() {
            this.loading = true;
            this.showError = false;
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$store.dispatch('login', this.model.fields).then(() => this.$store.dispatch('auth')).catch((error) => {
                        this.showError = true;
                        return Promise.reject(error);
                    }).then(() => {
                        this.$store.dispatch('preferences/getPreferences');
                        this.$store.dispatch('metrics/getMetrics');
                        this.$router.push({ name: 'home' });
                    }).catch((error) => {
                        this.$store.commit('clearToken');
                        return Promise.reject(error);
                    }).finally(() => {
                        this.loading = false;
                    });
                } else {
                    this.loading = false;
                    return false;
                }
            });
        }
    }
};
</script>
